<template>
    <cic-popup
        :saveable="editing"
        class="service-selector"
        title="Service Selection"
        save-button-label="Assign"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ServiceSelectorInner
                :editing="editing"
                :route="route"
                :access-type="accessType"
                @change="updateFieldValue"
            />
        </div>
        <template v-if="editing" #footer>
            <cic-button id="popup_remove" @click="$emit('remove')">
                {{ $t('Remove') }}
            </cic-button>
        </template>
    </cic-popup>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicPopup from '@/components/CicPopup';
    import ServiceSelectorInner from './ServiceSelectorInner';

    export default {
        name: 'ServiceSelector',
        components: {
            CicButton,
            CicPopup,
            ServiceSelectorInner,
        },
        props: {
            accessType: {
                type: Number,
                default: 0,
            },
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input', 'remove'],
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
